export interface IQuotaTableCondition {
    code: number;
    count: number;
}

export interface IQuotaTable {
    point: string;
    conditions: Array<IQuotaTableCondition>;
}

export interface IDataPointOption {
    code: number;
    title: string;
}

export interface IDataPoint {
    code: string;
    type: string;
    title: string;
    options: Array<IDataPointOption>;
    tags: Array<string>;
}

export interface IDataPoints {
    points: Array<IDataPoint>;
    categories: Array<{ id: number; name: string }>;
    isDataPointsLoaded: boolean;
}

export const enum CampaignStatus {
    DRAFT = 'draft',
    PENDING = 'pending',
    OPEN = 'open',
    PAUSED = 'paused',
    CLOSED = 'closed',
}

export interface IRespondentsCampaign {
    id: number;
    title: string;
    userId: number;
    surveyId: number;
    externalId: number;
    redirectLink: string;
    campaignData: {
        title: string;
        status: CampaignStatus;
        approveStatus: string;
        createdAt: string;
        settings: {
            fieldStartAt: string;
            fieldEndAt: string;
            categories: Array<number>;
            planLoi: number;
            totalQuota: number;
        };
        statistic?: {
            availableComplete: number | null;
            complete: number | null;
            quotafull: number | null;
            screenout: number | null;
        };
    };
}

export interface RespondentsState {
    walletBalance: number;
    campaigns: Array<IRespondentsCampaign>;
    isCampaignsLoaded: boolean;
    dataPoints: IDataPoints;
}

export const initialState: Readonly<RespondentsState> = {
    walletBalance: 0,
    campaigns: [],
    isCampaignsLoaded: false,
    dataPoints: {
        points: [],
        categories: [],
        isDataPointsLoaded: false,
    },
};
